import { createAsyncThunk } from '@reduxjs/toolkit'

import { ConnectedServiceData } from '@lyrahealth-inc/shared-app-logic/src/features/connectedService/types'

import { getConnectedServicesData } from '../../common/http/data/connectedService'

export const GET_CONNECTED_SERVICES = 'GET_CONNECTED_SERVICES'

export const getConnectedServices = createAsyncThunk<ConnectedServiceData[], string>(
  GET_CONNECTED_SERVICES,
  async (lyraId: string, { rejectWithValue }) => {
    try {
      const response = await getConnectedServicesData(lyraId)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const GET_CONNECTED_SERVICES_FULFILLED = getConnectedServices.fulfilled.type
export const GET_CONNECTED_SERVICES_PENDING = getConnectedServices.pending.type
export const GET_CONNECTED_SERVICES_REJECTED = getConnectedServices.rejected.type
